 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		31: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		31: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"VipCuratedFolderTooltip","1":"ActivityFeed","2":"AppStoreLink","3":"AuthModal","4":"AuthProvider","5":"CartNavDropdownContent","6":"Contact1stdibsModal","7":"Contact1stdibsModalAcuityEmbed","8":"Contact1stdibsModalTradeRepCircle","9":"ContactTradeRepModalChunk","10":"Conversations","11":"FavNotifications","12":"FbpvnyVpbaf","13":"MessageBanner","14":"MobileNavAppBanner","15":"MobileVipCuratedFolderCalloutContent","16":"NotificationQueue","17":"PrivacyPolicyChangeNoticeChunk","18":"TradeEnrollmentAndStatusUpdateLoader","19":"TradeEnrollmentAndStatusUpdateRenderer","20":"TradeGeneralOnboardingModalChunk","21":"TradeRewards2020LevelUpModalRenderer","22":"TradeRewardsLevelUpModalRendererWrapperChunk","23":"TradeVerifyFirmReminderToast","24":"VipCuratedFolderTooltipContent","25":"abandonCheckoutAutoModal","26":"abandonCheckoutPreAuthOfferMessageModal","27":"backToTop","28":"checkoutSurvey","29":"contactDealerModal","30":"cookieNotification","32":"googleLoginHandlers","33":"handleSocialLogin","34":"intlClientPolyfill","35":"makeOfferModal","36":"mobileFooter","37":"mobileHeader","38":"responsiveFooter","39":"responsiveHeader","40":"tradeAccountNavContent"}[chunkId]||chunkId) + "-legacy-buyer-2edd7ffc-008b-4365-842e-e01cef8940fc-" + "47db88614f3354724cf0" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"3":1,"4":1,"6":1,"8":1,"9":1,"11":1,"13":1,"14":1,"15":1,"17":1,"19":1,"20":1,"21":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"32":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"VipCuratedFolderTooltip","1":"ActivityFeed","2":"AppStoreLink","3":"AuthModal","4":"AuthProvider","5":"CartNavDropdownContent","6":"Contact1stdibsModal","7":"Contact1stdibsModalAcuityEmbed","8":"Contact1stdibsModalTradeRepCircle","9":"ContactTradeRepModalChunk","10":"Conversations","11":"FavNotifications","12":"FbpvnyVpbaf","13":"MessageBanner","14":"MobileNavAppBanner","15":"MobileVipCuratedFolderCalloutContent","16":"NotificationQueue","17":"PrivacyPolicyChangeNoticeChunk","18":"TradeEnrollmentAndStatusUpdateLoader","19":"TradeEnrollmentAndStatusUpdateRenderer","20":"TradeGeneralOnboardingModalChunk","21":"TradeRewards2020LevelUpModalRenderer","22":"TradeRewardsLevelUpModalRendererWrapperChunk","23":"TradeVerifyFirmReminderToast","24":"VipCuratedFolderTooltipContent","25":"abandonCheckoutAutoModal","26":"abandonCheckoutPreAuthOfferMessageModal","27":"backToTop","28":"checkoutSurvey","29":"contactDealerModal","30":"cookieNotification","32":"googleLoginHandlers","33":"handleSocialLogin","34":"intlClientPolyfill","35":"makeOfferModal","36":"mobileFooter","37":"mobileHeader","38":"responsiveFooter","39":"responsiveHeader","40":"tradeAccountNavContent"}[chunkId]||chunkId) + "-legacy-buyer-2edd7ffc-008b-4365-842e-e01cef8940fc-" + {"0":"31d6cfe0d16ae931b73c","1":"732330d07df3089ec7a0","2":"31d6cfe0d16ae931b73c","3":"3b96503f7a9ead47966c","4":"a7c6fa84e23c7908589b","5":"31d6cfe0d16ae931b73c","6":"65715d6cdff47ab5e77c","7":"31d6cfe0d16ae931b73c","8":"93d65ad745add28c2277","9":"7d12bf708c75dd7e54a5","10":"31d6cfe0d16ae931b73c","11":"468835ecd2be80082ca9","12":"31d6cfe0d16ae931b73c","13":"d1018306c373939ef984","14":"04919b72b0f6ef4ee48d","15":"e6c1b10ffcbf890911fd","16":"31d6cfe0d16ae931b73c","17":"1b48e3772f340726a452","18":"31d6cfe0d16ae931b73c","19":"0ea1b09dc9920b9ab4f6","20":"4a4a52b05a3131ff6731","21":"2bf4c74b2862fdcda16d","22":"31d6cfe0d16ae931b73c","23":"5373ac506ccd3ba339eb","24":"c8313e8145e4c009aea9","25":"7276a4a42e8ae1aad858","26":"fd1614fa0d915e01845c","27":"5f11c9dcb4579d6de332","28":"a066e2d1029120bd1109","29":"092c4b64dda95d2db30e","30":"b4a4786da060d6ef5e0b","32":"5e7b7204c68e68cd18b7","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"f8c8f17449401cf92626","36":"3f21d2dfd3e6de9619a6","37":"1a02d55cb9808ca26fb1","38":"f3df6b040657e332b955","39":"d9902d46af700d9254fd","40":"adebf9d141a07667eafc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://a.1stdibscdn.com/dist/dibs-buyer-layout/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpwindow_dibs_buyer_layout_buyer"] = window["webpackJsonpwindow_dibs_buyer_layout_buyer"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
